function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 0c.298 0 .539.241.539.539v.829a.539.539 0 01-1.078 0v-.83C7.461.242 7.702 0 8 0zM2.343 2.343c.21-.21.552-.21.762 0l.586.586a.539.539 0 01-.762.762l-.586-.586a.539.539 0 010-.762zM5.45 5.45a3.606 3.606 0 000 5.1l.454.454c.183.183.343.385.477.602h3.238c.134-.217.294-.42.477-.602l.454-.454a3.606 3.606 0 10-5.1-5.1zm4.977 6.92a2.26 2.26 0 01.431-.604l.454-.454a4.684 4.684 0 10-6.624 0l.453.454a2.26 2.26 0 01.662 1.597v.44a2.197 2.197 0 004.394 0v-.44a2.259 2.259 0 01.23-.993zm-1.238.314H6.81c.046.222.07.449.07.679v.44a1.12 1.12 0 002.238 0v-.44c0-.23.024-.457.07-.68zM0 8c0-.298.241-.539.539-.539h.829a.539.539 0 110 1.078h-.83A.539.539 0 010 8zm14.093 0c0-.298.242-.539.54-.539h.828a.539.539 0 110 1.078h-.829A.539.539 0 0114.093 8z",
  fill: "#2D2D2D"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.846 1.154a.526.526 0 010 .744L1.898 14.846a.526.526 0 11-.744-.744L14.102 1.154a.526.526 0 01.744 0z",
  fill: "#2D2D2D"
});
function SvgApagado(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default __webpack_public_path__ + "/img/Apagado.svg";
export { SvgApagado as ReactComponent };